import React, { createContext, useCallback, useContext, useState } from "react";
import api from "../services/api";
const AuthContext = createContext({});
const AuthProvider = ({ children }) => {
  const token = localStorage.getItem("@PR:token");
  const user = localStorage.getItem("@PR:User");
  const [email, setEmail] = useState("");
  const [data, setData] = useState(() => {
    if (user && token) {
      const userData = JSON.parse(user);
      return {
        ...userData,
      };
    }
    return null;
  });

  const [tempData, setTempData] = useState(() => {
    const temp = localStorage.getItem("@PR:tempData");
    if (temp) {
      const tempValue = JSON.parse(temp);
      return {
        ...tempValue,
      };
    }
    return null;
  });

  const signIn = useCallback(async ({ email, password, have_otp }) => {
    const response = await api.post("/api/users/login", {
      email,
      password,
      have_otp,
    });
    if (
      response?.status === 200 &&
      response?.data?.error &&
      response?.data?.data?.message === "Senha expirada"
    ) {
      const { email, token } = response.data.data.data;
      localStorage.setItem("@PR:tempData", JSON.stringify({ email, token }));
      setTempData({ email });
      return { success: true, resetPassword: true };
    }

    if (response.status === 200 && !response.data.error) {
      localStorage.removeItem("@PR:tempData");
      const { user: nUser, token } = response.data.data;
      setEmail(nUser.email);
      const validOtp =
        have_otp !== undefined ? have_otp : nUser.company.have_otp;
      if (!validOtp) {
        localStorage.setItem("@PR:User", JSON.stringify({ ...nUser }));
        localStorage.setItem("@PR:token", JSON.stringify(token));

        setData({
          ...nUser,
        });

        return {
          success: true,
          resetPassword: false,
          haveOtp: validOtp,
        };
      }
      return {
        success: true,
        resetPassword: false,
        haveOtp: validOtp,
        token,
      };
    }

    return { success: false, resetPassword: false };
  }, []);

  const resetPassword = useCallback(
    async (email, password) => {
      const response = await api.put("/api/users/change-password", {
        email,
        // token: tempData.token,
        password,
      });
      if (response.status === 200 && !response.data.error) {
        localStorage.setItem("@PR:User", JSON.stringify({ ...tempData }));
        const res = await signIn({ email: email, password });
        return res;
      }
      return true;
    },
    [signIn, tempData]
  );

  const signOut = useCallback(() => {
    localStorage.clear();
    setData(null);
  }, []);

  const userLogged = useCallback(() => {
    return token ? true : false;
  }, [token]);

  return (
    <AuthContext.Provider
      value={{
        user: data,
        email: email,
        signIn,
        resetPassword,
        userLogged,
        signOut,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

function useAuth() {
  const context = useContext(AuthContext);
  return context;
}
export { useAuth, AuthProvider };
